import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

/**
 * PayRedirect — bounces /api/payments/pay/{invoiceId} hits on the FRONTEND
 * domain straight to the BACKEND's /api/payments/pay/{invoiceId} endpoint,
 * which then 302s to a fresh Stripe Checkout session.
 *
 * Background: Before May 2026 the backend built pay-now URLs using
 * FRONTEND_URL as a fallback when BACKEND_URL env var wasn't set on Render.
 * Customers who received those emails / WhatsApp messages tap a link like
 *   https://app.streakfree.app/api/payments/pay/{id}
 * which lands on the React SPA instead of the backend redirect handler.
 * This component salvages those links so the customer still gets to Stripe.
 *
 * Set REACT_APP_BACKEND_URL to the backend's public domain. We never derive
 * it from window.location — that's the bug we're working around.
 */
const PayRedirect = () => {
  const { invoiceId } = useParams();
  const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

  useEffect(() => {
    if (!backendUrl || !invoiceId) return;
    // window.location.replace so the broken URL doesn't sit in browser history
    window.location.replace(`${backendUrl}/api/payments/pay/${invoiceId}`);
  }, [backendUrl, invoiceId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center" data-testid="pay-redirect-loading">
        <div className="inline-block w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-zinc-700 font-medium">Redirecting to secure payment…</p>
        <p className="text-zinc-500 text-sm mt-1">Please wait a moment.</p>
      </div>
    </div>
  );
};

export default PayRedirect;
